export const CopyText = (text) => ({
  showMessage: false,

  copy() {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.showMessage = true;

        setTimeout(() => {
          this.showMessage = false;
        }, 1000);
      });
    }
  },
});
